import { StateCreator, StoreApi, createStore } from "zustand";

type Getter<T> = () => T;
type Setter<T> = (partial: Partial<T>, replace?: boolean) => void;
type Listener<T> = (state: T, prevState: T) => void;

export class Store<T extends Record<string, any>> {
  private store: StoreApi<T>;
  constructor(data: StateCreator<T>) {
    this.store = createStore<T>(data);
  }
  get: Getter<T> = () => {
    return this.store.getState() as T;
  };
  set: Setter<T> = (partial: Partial<T>, replace?: boolean) => {
    // @ts-ignore
    this.store.setState(partial, replace);
  };
  subscribe = (listener: Listener<T>) => {
    this.store.subscribe(listener as any);
  };
  getStore() {
    return this.store;
  }
}
